import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-2" }
const _hoisted_2 = { "data-qa": "follow-success" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.Resources.Account.FollowProjectAsGuestSuccessModalDescription), 1 /* TEXT */),
    _createVNode(_component_base_button, {
      class: "_as-fe",
      onClick: $options.onClose,
      "data-qa": "close"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.Common.ModalCloseButton), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick"])
  ]))
}